import SearchCoreModal, { SearchCoreProps } from './SearchCoreModal';
import { WorkerTitle } from '../SiteClasses';
import { addCommas } from '../SiteUtil';
import API from '../API';

var SearchTitleModal = (props: SearchCoreProps<WorkerTitle>)=>{
	return <SearchCoreModal
		{...props}
		title='Buscar puesto'
		onShowLoad={(query, page, page_size)=>{
			return API.searchTitles(null, 0, 15);
		}}
		searchData={(query, page, page_size)=>{
			return API.searchTitles(query, page * page_size, page_size);
		}}
		pageSize={10}
		table={[
			{ name: 'ID', key: 'title_id', collapsing: true },
			{ name: 'Nombre', key: 'title_name', collapsing: false },
			{ name: 'Sueldo base', key: 'payout_amount', collapsing: true, render: addCommas }
		]}
	/>
}

export default SearchTitleModal;